(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var n1 = 'number';
var n2 = 'number, number';
export function notNumber(x) {
  return !x;
}
notNumber.signature = n1;
export function orNumber(x, y) {
  return !!(x || y);
}
orNumber.signature = n2;
export function xorNumber(x, y) {
  return !!x !== !!y;
}
xorNumber.signature = n2;
export function andNumber(x, y) {
  return !!(x && y);
}
andNumber.signature = n2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(n1, "n1", "/home/yatham/Dev_BHS_Portal/node_modules/mathjs/lib/esm/plain/number/logical.js");
  reactHotLoader.register(n2, "n2", "/home/yatham/Dev_BHS_Portal/node_modules/mathjs/lib/esm/plain/number/logical.js");
  reactHotLoader.register(notNumber, "notNumber", "/home/yatham/Dev_BHS_Portal/node_modules/mathjs/lib/esm/plain/number/logical.js");
  reactHotLoader.register(orNumber, "orNumber", "/home/yatham/Dev_BHS_Portal/node_modules/mathjs/lib/esm/plain/number/logical.js");
  reactHotLoader.register(xorNumber, "xorNumber", "/home/yatham/Dev_BHS_Portal/node_modules/mathjs/lib/esm/plain/number/logical.js");
  reactHotLoader.register(andNumber, "andNumber", "/home/yatham/Dev_BHS_Portal/node_modules/mathjs/lib/esm/plain/number/logical.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();